import moment from 'moment';
import { DATETIME_DISPLAY_FORMAT } from '../../constant';

export const parseServerDate = (date) => {
  if (!date) return undefined;

  if (typeof date === 'string') {
    return moment(date).utc();
  }

  if (typeof date === 'number') {
    return moment.unix(date).utc();
  }

  return date;
};

export const formatDate = (date, format = DATETIME_DISPLAY_FORMAT, emptyText = '-') => {
  if (!date) return emptyText;
  if (typeof date === 'string') {
    return moment(date).utc().format(format);
  }
  if (typeof date === 'number') {
    return moment.unix(date).utc().format(format);
  }
  return emptyText;
};
